import { Link } from '@chakra-ui/next-js';
import { Box, Button, Icon, Stack } from '@chakra-ui/react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

export const Pagination = ( { page, totalPages, basePath } ) => {

	return (
		<Box as="nav" aria-label="Pagination" mt={ 12 }>
			<Stack direction="row" spacing={ 4 } justify="space-between">
				{ page === 1 ? (
					<Button size="md" variant="ghost" leftIcon={ <Icon as={ FaChevronLeft } /> } isDisabled={ page === 1 }>
						Precedente
					</Button>
				) : (
					<Button as={ Link } href={ `${basePath}/${page - 1}` } size="md" variant="ghost" leftIcon={ <Icon as={ FaChevronLeft } /> } isDisabled={ page === 1 }>
						Precedente
					</Button>
				) }

				{ page === totalPages ? (
					<Button size="md" variant="ghost" rightIcon={ <Icon as={ FaChevronRight } /> } isDisabled={ page === totalPages }>
						Successiva
					</Button>
				) : (
					<Button as={ Link } href={ `${basePath}/${page + 1}` } size="md" variant="ghost" rightIcon={ <Icon as={ FaChevronRight } /> } isDisabled={ page === totalPages } >
						Successiva
					</Button>
				) }
			</Stack>
		</Box >
	);

};
